var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 10.1111C14.359 10.1111 15.0554 9.41466 15.0554 8.55556C15.0554 7.69645 14.359 7 13.4999 7C12.6408 7 11.9443 7.69645 11.9443 8.55556C11.9443 9.41466 12.6408 10.1111 13.4999 10.1111Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0559 7.85417C15.0559 7.85417 22.6937 6.6564 22.8181 4.52529C22.9426 2.39417 16.5959 4.52529 16.5959 4.52529",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7023 24.0467H6.31344C5.5201 24.0467 4.88232 23.5489 4.88232 22.9267V9.59561C4.88232 9.2845 5.03788 9.0045 5.31788 8.78672L12.5045 3.32672C13.0645 2.90672 13.9512 2.90672 14.5112 3.32672L21.6979 8.78672C21.9779 9.0045 22.1334 9.2845 22.1334 9.59561V22.9267C22.1334 23.5334 21.4957 24.0467 20.7023 24.0467Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5444L12.4889 3.32667C13.0956 2.89111 13.92 2.89111 14.5267 3.32667L24.0156 10.5289",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.21b47975.svg";
export { ForwardRef as ReactComponent };